import { DsEmptyState } from '@/ds/empty-state'
import { ApiError } from '@/lib/api'

export const fetchErrorStrings = {
  title: 'Something went wrong',
  hint: 'Check your connection and try again.',
  retry: 'Retry',
}

// Shows the server's message unless it is the generic one, then the connection hint.
export function DsFetchErrorState({ error, onRetry, title = fetchErrorStrings.title, compact }: { error: unknown; onRetry?: () => void; title?: string; compact?: boolean }) {
  const message = error instanceof ApiError ? error.message : error instanceof Error ? error.message : ''
  const generic = !message || /something went wrong/i.test(message)
  return <DsEmptyState.Error title={title} description={generic ? fetchErrorStrings.hint : message} actionLabel={onRetry ? fetchErrorStrings.retry : undefined} onAction={onRetry} compact={compact} />
}
